import { useState } from "react";
import { Route, Routes } from "react-router-dom";
import Header from "./components/Navigation/Header";
import MobileNav from "./components/Navigation/MobileNav";
import Planet from "./components/Planets/Planet";

const App = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  return (
    <main>
      <Header handler={toggleMenu} />
      {isOpen && <MobileNav handler={toggleMenu} />}

      <Routes>
        <Route
          path="/"
          element={<Planet planetName="earth" view="overview" />}
        />
        <Route
          path="/mercury"
          element={<Planet planetName="mercury" view="overview" />}
        />
        <Route
          path="/venus"
          element={<Planet planetName="venus" view="overview" />}
        />
        <Route
          path="/earth"
          element={<Planet planetName="earth" view="overview" />}
        />
        <Route
          path="/mars"
          element={<Planet planetName="mars" view="overview" />}
        />
        <Route path="/jupiter" element={<Planet planetName="jupiter" />} />
        <Route path="/saturn" element={<Planet planetName="saturn" />} />
        <Route path="/uranus" element={<Planet planetName="uranus" />} />
        <Route path="/neptune" element={<Planet planetName="neptune" />} />
      </Routes>
    </main>
  );
};

export default App;
